/* eslint-disable react/jsx-no-constructed-context-values */
/**
 * This is the starting point of your application.
 * Feature Hub Apps will use this file to bootstrap the app.
 */
import React from 'react';
import { ThemeProvider } from '@oneaudi/unified-web-common';
import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import InpageNav from './components/inpageNav/InpageNav';
import { FalconContent } from './contentMapping';
import { InPageNavConfig, InternalLink, Theme } from '../types';
import { InPageNavProvider, TrackingServiceContext } from './context';
import { getThemeName } from './utils/alpha-helpers';

interface FeatureAppProps {
  content: FalconContent;
  trackingService: TrackingServiceV2;
}

const FeatureApp: React.FC<FeatureAppProps> = (props: FeatureAppProps) => {
  const { content, trackingService } = props;

  const state: InPageNavConfig = {
    parentPageInpageNavigation: content?.fields
      ?.parentPageInpageNavigation as unknown as InternalLink,
    sameLevelInpageNavigation: content?.fields?.sameLevelInpageNavigation || [],
    subLevelInpageNavigation: content?.fields?.subLevelInpageNavigation || [],
    accordionLabel: content?.fields?.accordionLabel || '',
    priorityNavActive: {
      isDesktop: false,
      interaction: 0,
    },
    uiTheme: content?.fields?.uiTheme === 'dark' ? Theme.DARK : Theme.LIGHT,
    removeStickiness: content?.fields?.removeStickiness || false,
  };

  const theme = getThemeName(state.uiTheme);

  return (
    <ThemeProvider theme={theme}>
      <InPageNavProvider inPageNavValue={state}>
        <TrackingServiceContext.Provider value={{ trackingService }}>
          <InpageNav />
        </TrackingServiceContext.Provider>
      </InPageNavProvider>
    </ThemeProvider>
  );
};

export default FeatureApp;
